import styled from "@emotion/styled";
import { PageHeaderVariant } from "./PageHeader";

export const PageHeaderRoot = styled.div<{ variant: PageHeaderVariant }>(({ theme, variant }) => ({
	boxSizing: "border-box",
	width: "100%",
	...(variant === "title"
		? {
				minHeight: 82,
				padding: "20px 32px",
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				gap: 16,
				background: "linear-gradient(90deg, #006594 0%, #ffffff 100%)",
				h1: {
					margin: 0,
					color: theme.project.colors.fontColors.label,
					fontFamily: "Gibson, sans-serif",
					fontSize: "34px",
					fontWeight: 400,
					lineHeight: "42px"
				},
				".page-header-actions": {
					display: "flex",
					alignItems: "center",
					gap: 8
				},
				[theme.breakpoints.down("md")]: {
					minHeight: 0,
					padding: 16,
					alignItems: "flex-start",
					flexDirection: "column",
					".page-header-actions": {
						width: "100%",
						flexWrap: "wrap"
					}
				}
			}
		: {
				margin: 16,
				padding: 24,
				backgroundColor: theme.project.colors.backgroundColors.main,
				[theme.breakpoints.down("md")]: {
					margin: 16,
					padding: 16
				}
			})
}));
